// extracted by mini-css-extract-plugin
module.exports = {"popup-content-default":"ThreeDots_popup-content-default__pmLjK","labels-mode":"ThreeDots_labels-mode__K6Uj7"};